import { render, staticRenderFns } from "./FileStructuralSignatureSummary.vue?vue&type=template&id=03b81d5b&scoped=true"
import script from "./FileStructuralSignatureSummary.vue?vue&type=script&lang=ts"
export * from "./FileStructuralSignatureSummary.vue?vue&type=script&lang=ts"
import style0 from "./FileStructuralSignatureSummary.vue?vue&type=style&index=0&id=03b81d5b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03b81d5b",
  null
  
)

export default component.exports